function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.6174 0H1.90303C1.61062 0 1.36288 0.102753 1.15982 0.308261C0.956755 0.51377 0.855225 0.764486 0.855225 1.06042V15.783C0.855225 16.0789 0.956755 16.3296 1.15982 16.5351C1.36288 16.7407 1.61062 16.8434 1.90303 16.8434H9.18895L11.2602 20L13.3315 16.8434H20.6174C20.9098 16.8434 21.1575 16.7407 21.3606 16.5351C21.5637 16.3296 21.6652 16.0789 21.6652 15.783V1.06042C21.6652 0.764486 21.5637 0.51377 21.3606 0.308261C21.1575 0.102753 20.9098 0 20.6174 0ZM19.5696 14.7472H12.308L11.2602 16.8434L10.2124 14.7472H2.95084V2.12084H19.5696V14.7472ZM5.02209 7.37361H17.4983V5.27743H5.02209V7.37361ZM5.02209 11.5906H17.4983V9.46979H5.02209V11.5906Z"
});

var SvgIcoComment2 = function SvgIcoComment2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "#FF785A",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoComment2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-comment2.9e110916.svg";
export { ForwardRef as ReactComponent };